<template>
  <div>
    <bita-breadcrumb :items="breadCrumbs" />
    <div class="wrapper wrapper-content animated fadeInRight">
      <bita-ibox :is-loading="isLoadingGrid">
        <div slot="body">
          <div class="col-12 col-md-3">

          </div>
          <hr />
          <bita-grid ref="grid" :columns="gridColumns" 
            :read-data="readData"
            :hasRow="false"
            :grid-server-side="true"
            :schema-total="'total'"
            :schema-data="'data'"
            :server-paging="true"
            :batch="true"
          
           />
        </div>
      </bita-ibox>
    </div>

  </div>
</template>
<script>
export default {
  data() {
    return {
      breadCrumbs: [
        { title: "صفحه اصلی", link: "/" },
        { title: "کمپین ها", link: "/campaigns" },
        { title: "سفارشات", link: "campaigns/products", active: true },
      ],
      isLoadingGrid: false,
      pageSize:0,
      currentPage:0
    };
  },
  computed: {
    gridColumns() {
      return [
        { title: "#", template: this.$getTemplate, width: "40px" },

        { field: "campaign.title", title: "عنوان کمپین", width: "100px" },
        { field: "driver.full_name", title: "راننده", width: "100px" },
        { field: "state.name", title: "وضعیت سفارش", width: "100px" },

        {
          field: "updated_at",
          title: "تاریخ پرداخت",
          template: (e) =>
            e.updated_at ? this.$getJalaliDateTime(e.updated_at) : "",
          width: "100px",
        },
        {
          title: "عملیات",
          command: this.gridCommands(),
          width: "150px",
        },
      ];
    },
  },
  methods: {


 readData(e) {
      this.pageSize = e.data.pageSize;
      this.currentPage = e.data.page;
      this.$resetGrid();
      this.isLoadingGrid = true;
const baseUrl = `campaigns/orders?page=${this.currentPage}&page_size=${this.pageSize}`;
      let url = this.$makeQueryStringForSpatie(baseUrl, "&");
      this.$persistClient("get", url)
        .then((res) => {
          e.success(res.data);
        })
        .catch(() => {
          e.success([]);
        })
        .finally(() => {
          this.isLoadingGrid = false;
        });
    },



    loadData() {
      this.$refs.grid.loadDataSource();
    },
    gridCommands() {
      let commands = [];

      if (this.$acl.can("delete", "orders"))
        commands.push({
          text: "delete",
          click: this.delete,
          template: this.gridButtons.delete,
        });
      return commands;
    },
    delete(e) {
      let order = this.$refs.grid.getSelectedGridRow(e);
      this.$alert(
        "question",
        `آیا از حذف سفارش ${order.driver.name} اطمینان دارید ؟`,
        "",
        {
          confirmButtonText: "بله",
        }
      ).then((result) => {
        if (result.value) {
          this.isLoadingGrid = true;
          this.$persistClient("delete", `campaigns/products/${campaign.id}`)
            .then((res) => {
              this.$izitoast("success", "عملیات موفق", res.data.message);
              this.loadData();
            })
            .finally(() => {
              this.isLoadingGrid = false;
            });
        }
      });
    },

  },
};
</script>
